/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Default_Max_Steps_LabelInputs */



/**
* | output |
* | --- |
* | "Default action limit" |
*
* @param {Agent_Policy_Default_Max_Steps_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_default_max_steps_label = /** @type {((inputs?: Agent_Policy_Default_Max_Steps_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Default_Max_Steps_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard-Aktionslimit")
	return /** @type {LocalizedString} */ ("Default action limit")
});